import React from 'react';

interface SearchBarProps {
  placeholder?: string;
  className?: string;
}

export const SearchBar: React.FC<SearchBarProps> = () => {
  // Docs search isn't built yet; render nothing rather than advertising a
  // disabled "Coming soon" input (looks unfinished to prospective customers).
  return null;
};

